import { UserDefaultIcon } from '@practium/ui';

export const farmerAnalysisChartData = [
	{ month: '01', realizado: 0, anoAnterior: 2 },
	{ month: '02', realizado: 2, anoAnterior: 3 },
	{ month: '03', realizado: 2, anoAnterior: 2 },
	{ month: '04', realizado: 1, anoAnterior: 2 },
	{ month: '05', realizado: 2, anoAnterior: 2 },
	{ month: '06', realizado: 3, anoAnterior: 2 },
	{ month: '07', realizado: 1, anoAnterior: 3 },
	{ month: '08', realizado: 2, anoAnterior: 2 },
	{ month: '09', realizado: 2, anoAnterior: 2 },
	{ month: '10', realizado: 3, anoAnterior: 2 },
	{ month: '11', realizado: 2, anoAnterior: 2 },
	{ month: '12', realizado: 2, anoAnterior: 2 },
];

export const farmerAnalysisChartConfig = {
	title: 'Análises de Solo',
	mainValue: '21 Análises',
	trendValue: '16.7%',
	trendLabel: 'vs ano anterior',
	trendDirection: 'up' as const,
	footerText: 'Análises de solo de Jan-Dez, ' + new Date().getFullYear(),
	buttonText: 'Ver Relatório',
	onButtonClick: () => { },
	xAxisKey: 'month',
	bar1Key: 'realizado',
	bar1Label: 'Realizado',
	bar2Key: 'anoAnterior',
	bar2Label: 'ano anterior',
};

export const farmerAnalysisTypeDonutData = [
	{ name: 'Solo', value: 12, color: 'var(--chart-donut-dark)' },
	{ name: 'Foliar', value: 8, color: 'var(--chart-donut-medium)' },
	{ name: 'Água', value: 1, color: 'var(--chart-donut-light)' },
];

export const farmerAnalysisTypeDonutConfig = {
	title: 'Tipos de Análise',
	subtitle: 'Distribuição por tipo',
	buttonText: 'Ver Relatório',
	onButtonClick: () => { },
};

export const farmerRecommendationsChartData = [
	{ name: 'Implementadas', value: 8 },
	{ name: 'Em Andamento', value: 5 },
	{ name: 'Pendentes', value: 2 },
];

export const farmerRecommendationsChartConfig = {
	title: 'Status de Recomendações',
	subtitle: 'Recomendações agronômicas',
	buttonText: 'Ver Relatório',
	onButtonClick: () => { },
};

export const farmerPropertiesData = [
	{ id: 1, name: 'Fazenda Santa Clara', value: '125 ha', icon: UserDefaultIcon },
	{ id: 2, name: 'Sítio Boa Vista', value: '85 ha', icon: UserDefaultIcon },
	{ id: 3, name: 'Chácara Esperança', value: '42 ha', icon: UserDefaultIcon },
];

export const farmerPropertiesConfig = {
	title: 'Quantidade de Propriedades',
	subtitle: 'Propriedades cadastradas',
	buttonText: 'Ver Relatório',
	onButtonClick: () => { },
};

export const farmerAnalysisConfig = {
	title: 'Quantidade de Análises',
	subtitle: 'Análises cadastradas',
	buttonText: 'Ver Relatório',
	onButtonClick: () => { },
}

export const farmerProductivityLineData = [
	{ day: '01', current: 85, previous: 78 },
	{ day: '02', current: 88, previous: 82 },
	{ day: '03', current: 92, previous: 85 },
	{ day: '04', current: 87, previous: 88 },
	{ day: '05', current: 95, previous: 86 },
	{ day: '06', current: 98, previous: 90 },
];

export const farmerProductivityLineConfig = {
	title: 'Produtividade Estimada',
	mainValue: '545 sc/ha',
	trendValue: '12.5%',
	trendLabel: 'vs safra anterior',
	trendDirection: 'up' as const,
	footerText: 'Produtividade de 1-6 Dez, 2025',
	buttonText: 'Ver Relatório',
	onButtonClick: () => { },
	xAxisKey: 'day',
	line1Key: 'current',
	line1Label: 'Safra Atual',
	line2Key: 'previous',
	line2Label: 'Safra Anterior',
	tooltipTitle: 'Produtividade',
};
